/**
 * Image-watermark pixel limits shared by watermarkImage.ts and the burn-in
 * worker. Imports nothing, so the worker can import it statically.
 */

/** Longest edge (px) an upload is rasterized to. Pairs with the worker's
 * WATERMARK_IMAGE_MAX_DPI. */
export const RASTER_MAX_EDGE = 1024;

/**
 * Longest edge (px) rendered from shared storage or embedded by the worker.
 * A byte cap is not a pixel cap: a 20000x20000 PNG compresses to a few KB.
 */
export const MAX_STORED_IMAGE_EDGE = 4 * RASTER_MAX_EDGE;
